import request from '@/request/request'


// 查询紧急求助列表
// export function findAllPage(data) {
//     return request({
//         url: '/jk/resource-api/resource/Bailout/findAllPage',
//         method: 'post',
//         data: data,
//         headers: {
//             'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
//         }
//     })
// }

// // 查询紧急求助详细
// export function bailoutDetail(id) {
//     return request({
//         url: '/jk/resource-api/resource/Bailout/bailoutDetail',
//         method: 'post',
//         data: id,
//         headers: {
//             'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
//         }
//     })
// }

//任务下发人 接收人接口
export function urbanUserList(data) {
    return request({
        url: '/jk/urban-server/urbanGridUser/listUser',
        method: 'get',
        data: data
    })
}
// 任务列表查询
export function taskList(data) {
    return request({
        url: '/jk/task-server/integratedTask/listTask',
        method: 'post',
        data: data,
    })
}
// 分页拉取全部任务（pageSize 上限 1000，内部自动翻页合并），供统计聚合
// query 不传 pageNum/pageSize，返回 { rows, total }
export function listAllTask(query) {
    const pageSize = 1000;
    const base = Object.assign({}, query || {});
    const fetchPage = (pageNum) =>
        taskList(Object.assign({}, base, { pageNum, pageSize }));
    return fetchPage(1).then((first) => {
        const rows = (first.rows || []).slice();
        const total = first.total || 0;
        const pages = Math.ceil(total / pageSize);
        if (pages <= 1) return { rows, total };
        const reqs = [];
        for (let p = 2; p <= pages; p++) reqs.push(fetchPage(p));
        return Promise.all(reqs).then((rest) => {
            rest.forEach((r) => rows.push.apply(rows, r.rows || []));
            return { rows, total };
        });
    });
}
// 任务详情
export function taskDetails(data) {
    return request({
        url: `/jk/urban-server/task/${data.id}`,
        method: 'get',
        data: data,
    })
}
// 任务督办
export function taskSupervise(data) {
    return request({
        url: `/jk/urban-server/task/supervise`,
        method: 'post',
        data: data,
    })
}
